import { render, staticRenderFns } from "./RuleGroupList.vue?vue&type=template&id=6d4a6e24&"
import script from "./RuleGroupList.vue?vue&type=script&lang=ts&"
export * from "./RuleGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports